import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgbActiveModal, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { round } from '@turf/turf'
import { ToastrService } from 'ngx-toastr'
import { NgxUiLoaderService } from 'ngx-ui-loader'
import { throwError } from 'rxjs'
import {
  catchError,
  finalize,
  first,
  map,
  pluck,
  switchMap,
  takeUntil,
} from 'rxjs/operators'
import {
  SaveVoyageDataPayload,
  VoyageData,
  VoyageHistoryPayload,
} from 'src/app/core/models/voyage-data-management'
import { VoyageStrategiesSavePayload } from 'src/app/core/models/voyage-planner'
import { FueleuDataManagementService } from 'src/app/core/services/fueleu-datamanagement.service'

@Component({
  selector: 'eu-data-management-detail',
  templateUrl: './eu-data-management-detail.component.html',
  styleUrls: ['./eu-data-management-detail.component.css'],
})
export class EuDataManagementDetailComponent implements OnInit {
  @Input() voyageData: VoyageData
  @Input() modal: NgbActiveModal
  @Input() readonly = false

  constructor(
    private ngxService: NgxUiLoaderService,
    private toastrService: ToastrService,
    private fueleuDataManagementService: FueleuDataManagementService
  ) {}

  ngOnInit() {
    this.formatDates()
  }

  formatDates() {
    if (this.voyageData.fromDate) {
      this.voyageData.fromDate = this.voyageData.fromDate.split('T')[0]
    }
    if (this.voyageData.toDate) {
      this.voyageData.toDate = this.voyageData.toDate.split('T')[0]
    }
    this.voyageData.cO2EmittedAtPort = round(this.voyageData.cO2EmittedAtPort,2);
    this.voyageData.cO2EmittedAtSea = round(this.voyageData.cO2EmittedAtSea,2);
    this.voyageData.lfoConsumedAtPort = round(this.voyageData.lfoConsumedAtPort,2);
    this.voyageData.lfoConsumedAtSea = round(this.voyageData.lfoConsumedAtSea,2);
    this.voyageData.mgoConsumedAtPort = round(this.voyageData.mgoConsumedAtPort,2);
    this.voyageData.mgoConsumedAtSea = round(this.voyageData.mgoConsumedAtSea,2);
    

  }

  selectedTab: string = 'general'

  selectTab(tab: string): void {
    this.selectedTab = tab
  }

  editVoyageDetails(voyageId: number): void {
    this.ngxService.start()
    const model: VoyageHistoryPayload = this.updateVoyageDetailsPayload
    this.fueleuDataManagementService
      .updateVoyage(model)
      .pipe(
        catchError(error => {
          this.toastrService.error(
            error.message,
            'Failed to update voyage details'
          )
          return throwError(() => new Error(error))
        }),
        finalize(() => this.ngxService.stop())
      )
      .subscribe(() => {
        this.toastrService.success('Voyage details updated successfully')
      })
  }

  toggleLock(voyageData: VoyageData) {
    this.fueleuDataManagementService
      .toggleLock(voyageData.id)
      .pipe(first())
      .subscribe(() => (voyageData.isLocked = !voyageData.isLocked))
  }

  get saveVoyageDetailsPayload(): SaveVoyageDataPayload {
    const payload = new SaveVoyageDataPayload([], [this.voyageData])
    return payload
  }

  get updateVoyageDetailsPayload(): VoyageHistoryPayload {
    const payload = new VoyageHistoryPayload(this.voyageData)
    return payload
  }
}
